// export const IMG_URL = "http://127.0.0.1:1919";

// export const IMG_URL = "http://127.0.0.1:7788";
export const IMG_URL = "https://funrepnode.profcymadev.com:7788";

export const Select2Data = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
}

export const IDS = {
  Roles: { List: 1, Add: 2, Edit: 3, Delete: 4 },
  Users: { List: 5, Add: 6, Edit: 7, Delete: 8 },
  Country: { List: 9, Add: 10, Edit: 11, Delete: 12 },
  State: { List: 13, Add: 14, Edit: 15, Delete: 16 },
  District: { List: 17, Add: 18, Edit: 19, Delete: 20 },
  Taluka: { List: 21, Add: 22, Edit: 23, Delete: 24 },
  Faq: { List: 25, Add: 26, Edit: 27, Delete: 28 },
  AppSetUp: { List: 29, Edit: 30 },
  About_Us: { List: 31, Add: 32, Edit: 33, Delete: 34 },
  Terms_and_Conditions: { List: 35, Add: 36, Edit: 37, Delete: 38 },
  Privacy_and_Policy: { List: 39, Add: 40, Edit: 41, Delete: 42 },
  Refund_Policy: { List: 43, Add: 44, Edit: 45, Delete: 46 },
  Inter_Budget: { List: 47, Add: 48, Edit: 49, Delete: 50 },
  Wallet_History: { List: 51, Edit: 52 },
  User_Wallet: { List: 53 },
  Post: { List: 54, Edit: 55 },
};
